module.exports = __webpack_public_path__ + "img/games03.39423079.png";